import { arrayToObject } from "@treelab/panda";
import { isArray, isUndefined } from "lodash";

import { ITableColumn, ITableData, ITableRowData, IWrokspaceData, PermissionNodeRoles } from "../types/table-type";

// 对 columns rows 进行预排序 顺序使用第一个视图的顺序
export const sortColumnsAndRows = (tableData: ITableData) => {
  const { columns, rows, views } = tableData;
  if (!isArray(views) || views.length === 0) return;
  const columnOrderObj = arrayToObject(views[0].columns || [], "id");
  columns.sort((a: ITableColumn, b: ITableColumn) => {
    return columnOrderObj[a.id].order - columnOrderObj[b.id].order;
  });
  const rowOrderObj = arrayToObject(views[0].rows || [], "id");
  // 因为后端数据问题 存在 row 在 view[0].rows 找不到对应的 row 在这里做数据保护
  rows.sort((a: ITableRowData, b: ITableRowData) => {
    const rowA = rowOrderObj[a.id];
    const rowB = rowOrderObj[b.id];
    const rowAIsUndefined = isUndefined(rowA);
    const rowBIsUndefined = isUndefined(rowB);
    if (rowAIsUndefined && rowBIsUndefined) {
      return 0;
    }
    if (rowAIsUndefined) {
      return -1;
    }
    if (rowBIsUndefined) {
      return 1;
    }
    return rowA.order - rowB.order;
  });
};

// 根据 workspace 中的 nodes 信息 判断是否具有 table 的 admin 权限
export const checkTablePermission = (workspaceData: IWrokspaceData, tableId: string): boolean => {
  const { nodes } = workspaceData;
  const tarTable = nodes.byId[tableId];
  if (!tarTable) return false;
  return tarTable.role === PermissionNodeRoles.ADMIN;
};
